/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Work_Activity_Status_OpenInputs */

const vi_work_activity_status_open = /** @type {(inputs: Work_Activity_Status_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang mở`)
};

/**

* @param {Work_Activity_Status_OpenInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const work_activity_status_open = /** @type {((inputs?: Work_Activity_Status_OpenInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_Activity_Status_OpenInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_work_activity_status_open(inputs)
});